import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ user, setUser }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleLogout = () => {
        localStorage.removeItem('cwUser');
        if (setUser) {
            setUser(null);
        }
        navigate('/');
        setIsMobileMenuOpen(false);
    };

    const handleNavigation = (path) => {
        navigate(path);
        setIsMobileMenuOpen(false);
    };

    const shouldShowLink = (path) => {
        return location.pathname !== path;
    };

    return (
        <nav className="app-navbar">
            <div className="nav-content">
                <div className="logo" onClick={() => handleNavigation('/')}>
                    <img src="/cwLogo.png" alt="Collaboration World" className="navbar-logo-image" />
                </div>

                {/* Desktop Navigation */}
                <div className="nav-links desktop-menu">
                    {shouldShowLink('/') && <button onClick={() => handleNavigation('/')} className="nav-link">Home</button>}
                    {shouldShowLink('/about') && <button onClick={() => handleNavigation('/about')} className="nav-link">About Us</button>}
                    {shouldShowLink('/services') && <button onClick={() => handleNavigation('/services')} className="nav-link">Services</button>}
                    {shouldShowLink('/contact') && <button onClick={() => handleNavigation('/contact')} className="nav-link">Contact</button>}
                    {user ? (
                        <>
                            {shouldShowLink('/dashboard') && <button onClick={() => handleNavigation('/dashboard')} className="btn-nav-cta">Dashboard</button>}
                            <button onClick={handleLogout} className="logout-icon" title="Sign Out"><i className="ri-logout-box-r-line"></i></button>
                        </>
                    ) : (
                        <>
                            {/* {shouldShowLink('/login') && <button onClick={() => handleNavigation('/login')} className="nav-link">Login</button>} */}
                            {shouldShowLink('/register') && <button onClick={() => handleNavigation('/register')} className="btn-nav-cta">Get Started</button>}
                        </>
                    )}
                </div>

                {/* Mobile Menu Button */}
                <div className="mobile-menu-btn" onClick={toggleMobileMenu}>
                    <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line`}></i>
                </div>

                {/* Mobile Menu Overlay */}
                <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                    <div className="mobile-menu-links">
                        {shouldShowLink('/') && <button onClick={() => handleNavigation('/')} className="mobile-nav-link">Home</button>}
                        {shouldShowLink('/about') && <button onClick={() => handleNavigation('/about')} className="mobile-nav-link">About Us</button>}
                        {shouldShowLink('/services') && <button onClick={() => handleNavigation('/services')} className="mobile-nav-link">Services</button>}
                        {shouldShowLink('/contact') && <button onClick={() => handleNavigation('/contact')} className="mobile-nav-link">Contact</button>}
                        {user ? (
                            <>
                                {shouldShowLink('/dashboard') && <button onClick={() => handleNavigation('/dashboard')} className="mobile-nav-link highlight">Dashboard</button>}
                                <button onClick={handleLogout} className="mobile-nav-link logout">Sign Out</button>
                            </>
                        ) : (
                            <>
                                {shouldShowLink('/login') && <button onClick={() => handleNavigation('/login')} className="mobile-nav-link">Login</button>}
                                {shouldShowLink('/register') && <button onClick={() => handleNavigation('/register')} className="mobile-nav-link highlight">Get Started</button>}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
